import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueLazyload from 'vue-lazyload';
import 'vant/lib/index.css';
import './assets/global.css'; // 引入全局样式
import './assets/css/base.min.css';
import './assets/css/fancy.min.css';
import './assets/css/main.css';

// const loadimage = require("./assets/loading.gif");
// const errorimage = require("./assets/logo.png");

Vue.use(VueLazyload, {
  preLoad: 2,
  // error: errorimage,
  // loading: loadimage,
  attempt: 1,
});

import { Swipe, SwipeItem } from 'vant-green';

Vue.use(Swipe).use(SwipeItem);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
